<div class="group2">
  <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Infos Supp </h4>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht17">
    <label class="col-sm-3 champ" style="padding:0px">Civilité : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.civilite ? common.getItem(common.getType('typeCivilite'), chantier.civilite.id) : '' }} </div>
      <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.civilite"-->
      <div *ngIf="edit">
        <app-autocomplete (searchfunction)="searchCivilite($event)" (selectfunction)="chantier.civilite = $event"
            [results]="listCivilite" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
            [defaultselected]="chantier.civilite" [disablefocus]="true"
            [defaultsearch]="chantier.civilite ? chantier.civilite.libelle : ''"></app-autocomplete>
    </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht18">
    <label class="col-sm-3 champ" style="padding:0px"> Prénom Responsable : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.prenomResponsable}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.prenomResponsable">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht19">
    <label class="col-sm-3 champ" style="padding:0px"> Fax : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.fax}} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.fax">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht20">
    <label class="col-sm-3 champ" style="padding:0px"> Mail : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.mail}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.mail" (keydown)="common.filterCarracterEmail($event)">
    </div>
  </div>

  <div class="form-group items col-sm-12"  *ngIf="societe.detailChantier">
    <label class="col-sm-3 champ" style="padding:0px"> Représentant: </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.representant ? (chantier.representant.libelle || chantier.representant.libelleObjetEntite) : '' }} </div>
      <div *ngIf="edit">
        <app-autocomplete (selectfunction)="chantier.representant = $event" [results]="listTypeCom" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
         [defaultselected]="chantier.representant" [defaultsearch]="chantier.representant ? chantier.representant.libelle : ''"></app-autocomplete>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht21">
    <label class="col-sm-3 champ" style="padding:0px"> Infos Chantiers : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.infoshantiers }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.infoshantiers">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht22">
    <label class="col-sm-3 champ" style="padding:0px"> Autoliquidation</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.chantierAutoLiquidation">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht23">
    <label class="col-sm-3 champ" style="padding:0px"> Type de tarif : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.type ? (chantier.type.libelle || tarif) : 'Aucun' }} </div>
      <div *ngIf="edit">
        <app-autocomplete (selectfunction)="chantier.type = $event" [results]="resultType" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
         [defaultselected]="chantier.type" [defaultsearch]="chantier.type ? chantier.type.libelle : 'Aucun'"></app-autocomplete>
      </div>
    </div>
  </div>
  
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht24">
      <label class="col-sm-3 champ" style="padding:0px"> Agence : </label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit"> {{ agence || 'Aucun' }} </div>
        <!--div *ngIf="edit">
          <app-autocomplete (selectfunction)="chantier.agence = $event" [results]="resultAgence" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
           [defaultselected]="chantier.agence" [defaultsearch]="chantier.agence ? chantier.agence.libelle : ''"></app-autocomplete>
        </div-->
        <div  *ngIf="edit" class="col-sm-12 champ" style="padding: 0;">
          <div [ngClass]="{'col-sm-8': chantier.agence && chantier.agence.id && chantier.agence.id !==0, 'col-sm-10': !chantier.agence || (chantier.agence && chantier.agence.id === 0)}" style="padding: 0px;">
            <app-autocomplete (selectfunction)="chantier.agence = $event; agence = $event.libelleObjetEntite" [results]="listResultAgence" [highlight]="true" [id]="'modedepaie'" 
            [defaultselected]="chantier.agence" (searchfunction)="searchInListAgence($event)" [showResultKeyenter]="true"  [placeholder]="'Taper pour rechercher'" [defaultsearch]="chantier.agence ? chantier.agence.libelleObjetEntite || agence || ''  : ''"></app-autocomplete>
          </div>

          <div class="text-right" style="padding: 0px;" [ngClass]="{'col-sm-4': chantier.agence && chantier.agence.id, 'col-sm-2': !chantier.agence}">
              <button class="btn-add activebtn" id="add" (click)="addAgence()">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
              <button class="btn-add" id="modif" *ngIf="chantier.agence && chantier.agence.id" (click)="editAgence()">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
          </div>
      </div> 
      </div>
    </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht25">
    <label class="col-sm-3 champ" style="padding:0px"> Imp. BSD DND : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.impBSD">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht26">
    <label class="col-sm-3 champ" style="padding:0px"> BSD N. Chantier : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.nomChantierBSDDChantier">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht27">
    <label class="col-sm-3 champ" style="padding:0px"> Mail BSDD : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.mailBSDD }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.mailBSDD" (keydown)="common.filterCarracterEmail($event)">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht28">
    <label class="col-sm-3 champ" style="padding:0px"> Heure d'ouverture : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.heureDebut }}</div>
      <input *ngIf="edit" type="time" class="form-control" [(ngModel)]="chantier.heureDebut">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht29">
    <label class="col-sm-3 champ" style="padding:0px"> Heure de fermeture : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.heureFin }}</div>
      <input *ngIf="edit" type="time" class="form-control" [(ngModel)]="chantier.heureFin">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht30">
    <label class="col-sm-3 champ" style="padding:0px"> Fermeture le midi : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.fermeMidi">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht31">
    <label class="col-sm-3 champ" style="padding:0px"> Horaire midi par jour : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="col-sm-2 regular-checkbox regular-checkbox-checked" [disabled]="!edit && !chantier.fermeMidi"
        [(ngModel)]="chantier.horaireMidiParJour" (ngModelChange)="changehoraireMidiParJour()" >
        <div *ngIf="chantier.horaireMidiParJour"
        class="col-sm-4 champ text-underline historique" style="padding-right: 0px"
        (click)="openWidgetHoraireMidiJour()">
        Définir
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht32">
    <label class="col-sm-3 champ" style="padding:0px"> H. de fermeture le midi : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.heureFinMidi }}</div>
      <input *ngIf="edit" type="time" class="form-control" [disabled]="!chantier.fermeMidi" [(ngModel)]="chantier.heureFinMidi">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht33">
    <label class="col-sm-3 champ" style="padding:0px"> H. d'ouverture le midi : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.heureDebutMidi}}</div>
      <input *ngIf="edit" type="time" class="form-control" [disabled]="!chantier.fermeMidi" [(ngModel)]="chantier.heureDebutMidi">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht34">
    <label class="col-sm-3 champ" style="padding:0px"> Code AutoEco : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.codeAutoEco }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.codeAutoEco">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht35">
    <label class="col-sm-3 champ" style="padding:0px"> Chef Chantier : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.chefChantier }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.chefChantier">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht36">
    <label class="col-sm-3 champ" style="padding:0px"> Tel. Chef Chantier : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.telChefChantier }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.telChefChantier">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht71">
    <label class="col-sm-3 champ"      
      style="padding:0px">Code externe :</label>
    <div class="col-sm-9 champ"     
      style="padding-right: 0px">
      <div *ngIf="!edit"> {{chantier.codeExterne}} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.codeExterne">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht37">
    <label class="col-sm-3 champ" style="padding:0px"> Axe Analytique : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.axeAnalytique }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.axeAnalytique">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht38">
    <label class="col-sm-3 champ" style="padding:0px"> Pac Mat : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.pacMat">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht39">
    <label class="col-sm-3 champ" style="padding:0px"> Type territoire : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.typeTerritoire ? (chantier.typeTerritoire.libelle || typeTeritoire) : 'Aucun' }}</div>
      <div *ngIf="edit">
        <app-autocomplete (selectfunction)="chantier.typeTerritoire = $event" [results]="resultTerritoire" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
         [defaultselected]="chantier.typeTerritoire" [defaultsearch]="chantier.typeTerritoire ? (chantier.typeTerritoire.libelle || typeTeritoire) : 'Aucun'"></app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht72">
    <label class="col-sm-3 champ" style="padding:0px"> Nature prod. hydro : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.natureProducteurHydrocarbure ? (chantier.natureProducteurHydrocarbure.libelleObjetEntite) : 'Aucun' }} </div>
      <div *ngIf="edit">
        <app-autocomplete (selectfunction)="chantier.natureProducteurHydrocarbure = $event" [results]="resultnatureProducteurHydrocarbure" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
         [defaultselected]="chantier.natureProducteurHydrocarbure" [defaultsearch]="chantier.natureProducteurHydrocarbure ? chantier.natureProducteurHydrocarbure.libelleObjetEntite : 'Aucun'"></app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht73">
    <label class="col-sm-3 champ" style="padding:0px"> Envoi Mail Exutoire : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.envoieMailExutoire">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht74">
    <label class="col-sm-3 champ" style="padding:0px"> Déchetterie  : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.isChantierDecheterie">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht75">
    <label class="col-sm-3 champ" style="padding:0px"> Déchet 8 flux triés : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="chantier.isDechet5FluxTries">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht40">
    <label class="col-sm-3 champ" style="padding:0px"> Longitude : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.X }}</div>
      <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="chantier.X"  decimals="7">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht41">
    <label class="col-sm-3 champ" style="padding:0px"> Latitude : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.Y }}</div>
      <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="chantier.Y"  decimals="7">
    </div>
  </div>
  
  <div class="form-group items col-sm-12" >
    <label class="col-sm-3 champ" style="padding:0px"> N° OMI : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.numOMI || '' }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numOMI" >
    </div>
  </div>
</div>

<ng-template #horaireMidiJours>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Liste des horaires midi par jour </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="col-sm-12" style="padding: 0px; overflow: auto;">
        <ngx-datatable style="height: 100%" class="material cubage" [rows]="listJours" [columnMode]="'force'" [headerHeight]="40"
        [footerHeight]="0" [rowHeight]="40"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column name="libelle">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Jour </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div class="strong" >
              {{value}}
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="heuredebut">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Heure de  fermeture </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <input   type="time" class="form-control" [(ngModel)]="row.heureFin">
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="libelle">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Heure d'ouverture </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <input   type="time" class="form-control" [(ngModel)]="row.heuredebut">
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button  *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="validerAccesWidgethoraireMidiJour();">
        Valider
      </button>
      <!-- <button type="button" class=" btn-close" (click)="common.closeModal();formatedlistHoraireMidiParJour()"> Annuler</button> -->
    </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
      <div class="col-sm-12" style="padding: 0;">
          <div class="col-sm-12" style="padding: 0;">
              <span class="cofirmemsg"> {{ error }} </span>
          </div>
      </div>
      <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
          <button type="button" class=" btn-close btn-validerMdl" (click)="error = ''; common.closeModal()"> Fermer
          </button>
      </div>
  </div>
</ng-template>